type TModalInfo = {
  onOpen: () => void
  priority: number
  nextOneIsManual?: boolean
}

const OPEN_MODAL_TIMEOUT = 4000
const MODAL_COUNT_LIMIT = 2

class StartupModalHandler {
  private modals: TModalInfo[] = []

  private activated: boolean = false

  private openedModalCount = 1

  constructor() {
    this.modals = []
  }

  private sort() {
    this.modals = this.modals.sort((a, b) => b.priority - a.priority)
  }

  public openNextModal() {
    const modal = this.modals.shift()
    if (modal?.onOpen) {
      if (this.openedModalCount > MODAL_COUNT_LIMIT) return // MAXIMUM MODAL_COUNT_LIMIT MODAL
      this.openedModalCount += 1
      modal?.onOpen()
      if (!modal.nextOneIsManual) this.openNextModal()
    }
  }

  public run() {
    if (this.activated) return
    this.activated = true

    setTimeout(() => {
      this.sort() // SORT BASED ON PRIORITY

      this.openNextModal()
    }, OPEN_MODAL_TIMEOUT) // EACH ROUND FIVE SECONDS
  }

  public add(payload: TModalInfo) {
    this.modals.push({ nextOneIsManual: false, ...payload })
  }
}

export const StartUpModalQueue = new StartupModalHandler()
